import { computed, createBlock, openBlock, withCtx, createTextVNode, createElementVNode, createVNode, unref, renderSlot } from "vue";
import _sfc_main$2 from "./control_string.vue.js";
import _sfc_main$1 from "./control_iterable.vue.js";
import _sfc_main$3 from "./control_dynamic.vue.js";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { deserializeControlValue, serializeControlValue } from "../../lib/control.js";
import { OrderedObject } from "../../lib/ordered_object.js";
/* empty css                    */
const _hoisted_1 = { class: "d-d-grid d-g-cols2" };
const _hoisted_2 = {
  class: "d-d-flex",
  "data-qa": "dtc-control-object-item-key"
};
const _hoisted_3 = /* @__PURE__ */ createElementVNode("span", { class: "d-px6 d-ps-relative d-t6" }, ":", -1);
const _hoisted_4 = {
  class: "dtc-control-object__contents",
  "data-qa": "dtc-control-object-item-value"
};
const __default__ = {
  name: "DtcControlObject"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const entries = computed(() => {
      return props.value ? Object.entries(props.value) : [];
    });
    const keys = computed(() => {
      return entries.value.map(([key]) => key);
    });
    let currentId = 0;
    function generateNextId() {
      while (keys.value.includes(currentId.toString())) {
        currentId++;
      }
      return currentId.toString();
    }
    function generateItem() {
      return [generateNextId(), void 0];
    }
    function updateKey(key, value, updateItem) {
      if (keys.value.includes(key)) {
        const id = generateNextId();
        console.log(`Object cannot contain duplicate key '${key}', key set to '${id}'`);
        key = id;
      }
      updateEntry(key, value, updateItem);
    }
    function updateEntry(key, value, updateItem) {
      updateItem([key, value]);
    }
    function updateValue(e) {
      const orderedObject = OrderedObject.fromEntries(e);
      emit(VALUE_UPDATE_EVENT, orderedObject);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        value: entries.value,
        disabled: __props.disabled,
        "generate-item": generateItem,
        "onUpdate:value": updateValue
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        prefix: withCtx(() => [
          createTextVNode(" { ")
        ]),
        item: withCtx(({ item, update }) => [
          createElementVNode("div", _hoisted_1, [
            createElementVNode("div", _hoisted_2, [
              createVNode(_sfc_main$2, {
                value: item[0],
                disabled: __props.disabled,
                "onUpdate:value": (e) => updateKey(e, item[1], update)
              }, null, 8, ["value", "disabled", "onUpdate:value"]),
              _hoisted_3
            ]),
            createElementVNode("div", _hoisted_4, [
              createVNode(_sfc_main$3, {
                class: "dtc-control-object__contents",
                "input-class": "d-gc-full",
                value: unref(serializeControlValue)(item[1]),
                disabled: __props.disabled,
                "onUpdate:value": (e) => updateEntry(item[0], unref(deserializeControlValue)(e), update)
              }, null, 8, ["value", "disabled", "onUpdate:value"])
            ])
          ])
        ]),
        suffix: withCtx(() => [
          createTextVNode(" } ")
        ]),
        _: 3
      }, 8, ["value", "disabled"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_object.vue.js.map
